import { render } from "./TopLevelMenuFilteredItem.vue?vue&type=template&id=3a2f7fad&scoped=true"
import script from "./TopLevelMenuFilteredItem.vue?vue&type=script&lang=js"
export * from "./TopLevelMenuFilteredItem.vue?vue&type=script&lang=js"

import "./TopLevelMenuFilteredItem.vue?vue&type=style&index=0&id=3a2f7fad&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2f7fad"]])

export default __exports__